/**
 * 房源卡片
 * 
 * @Author: Focci
 * @Date: 2023-07-18 10:55:51
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 10:55:51
 */

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import Scrollbar from '@comp/Scrollbar'
import { houseSearchType } from '@lib/config'
import { useMemo } from 'react'
import { isArray, map, pick } from 'lodash-es'
import { PopupCardSkeleton, PropertyCard } from './PropertyCards'
import Boundary from '../Boundary'
import BoundaryText from '../BoundaryText'

export const apiMaps = {
  sold: 'trading-records/map',
  estimate: 'property-simple',
  stateHouse: 'property-simple',
}

function getPropertyData(type, data) {
  if(!isArray(data)) return []

  return map(data, (item) => {
    const tmp = pick(item, ['bathrooms', 'bedrooms', 'carspaces', 'slug'])
    
    if(type === 'sold') {
      tmp.id = item.id
      tmp.name = item.teaser || item.price_label
      tmp.street = item.street_address
      tmp.cover = item.cover_oss
      tmp.price = item.price_label
    } else if(type === 'estimate' || type === 'stateHouse') {
      tmp.id = item.id
      tmp.boundaries = item.boundaries
      tmp.boundaryDistances = item.boundary_distances
      tmp.name = ((item.avmLow && item.avmHigh) ? `${item.avmLow} - ${item.avmHigh}` : item.avm) || item.soldPrice
      tmp.street = item.address
      tmp.cover = item.houseImage || (item.images && item.images[0])
      tmp.carspaces = item.carSpaces
      tmp.floorarea = item.floorArea
      tmp.landarea = item.landArea
      tmp.price = item.soldPrice
      tmp.estimateType = item.type
    } else {
      tmp.id = item.id
      tmp.name = item.teaser
      tmp.street = item.street || item.street_address
      tmp.cover = item.pic
      tmp.price = item.price_bold
      tmp.priceLight = item.price_light
      tmp.floorarea = item.floorarea
      tmp.landarea = item.landarea
    }

    return { ...tmp, type }
  })
}

export default function PropertyPopupContent({
  point = {},
  type = ''
}) {
  const ids = isArray(point.points) ? map(point.points, 'id') : null
  const url = ids 
    ? `${(apiMaps[type] || 'houses')}/${ids.join(',')}`
    : null
  
  const { data, isLoading } = useFetch(url)
  const properties = useMemo(() => getPropertyData(type, data), [data, type])
  
  if(isLoading) {
    return (
      <PopupCardSkeleton showCover={type !== houseSearchType.estimate} />
    )
  }
  
  return (
    <Scrollbar autoHeight>
      <div className="flex flex-col gap-2">
        {properties.map((item) => (
          <PropertyCard 
            key={item.id}
            type={type}
            data={item}
          />
        ))}
      </div>
      {properties.length > 0 && properties[0].boundaries && (
        <Boundary data={properties[0].boundaries} />
      )}
      {properties.length > 0 && properties[0].boundaryDistances && (
        <BoundaryText 
          data={properties[0].boundaryDistances}
        />
      )}
    </Scrollbar>
  )
}

PropertyPopupContent.propTypes = {
  point: PropTypes.object,
  type: PropTypes.string,
}
